import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { store } from './store'; // Your Redux store
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';


import { GoogleOAuthProvider } from '@react-oauth/google';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="393954976438-gafhoadrsao45md581r6k5nrchkoslqc.apps.googleusercontent.com">
      <Provider store={store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// Disable service workers inside Capacitor layouts to avoid boot stalls
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// // frontend/web/src/index.tsx or main.tsx
// import React from 'react';
// import { createRoot } from 'react-dom/client';
// import { Provider } from 'react-redux';
// import { store } from './store'; // Your Redux store
// import App from './App';

// const container = document.getElementById('root');
// const root = createRoot(container!);

// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </React.StrictMode>
// );
